var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.24 10.5H24.26C22.4623 10.5 21 11.9752 21 13.7888V29.5215C21 31.335 22.4623 32.8102 24.26 32.8102H40.9223L47.0666 36.1667V32.8102H49.24C51.0377 32.8102 52.5 31.335 52.5 29.5215V13.7888C52.5 11.9752 51.0377 10.5 49.24 10.5Z",
    fill: "#0075F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.333 14.9838H26.833V16.4203H44.333V14.9838Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4695 18.9322H26.833V20.3687H38.4695V18.9322Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4904 22.8806H26.833V24.3171H33.4904V22.8806Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -0.0200002,
    y: 16.3134,
    width: 38.54,
    height: 32.7066
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.76px)",
      clipPath: "url(#bgblur_0_3094_7587_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 3.52,
    d: "M6.76 19.8334H31.74C33.5377 19.8334 35 21.3086 35 23.1221V38.8549C35 40.6684 33.5377 42.1436 31.74 42.1436H15.0777L8.9334 45.5V42.1436H6.76C4.9623 42.1436 3.5 40.6684 3.5 38.8549V23.1221C3.5 21.3086 4.9623 19.8334 6.76 19.8334Z",
    fill: "#D2E7FF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_3094_7587_clip_path",
    transform: "translate(0.0200002 -16.3134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.76 19.8334H31.74C33.5377 19.8334 35 21.3086 35 23.1221V38.8549C35 40.6684 33.5377 42.1436 31.74 42.1436H15.0777L8.9334 45.5V42.1436H6.76C4.9623 42.1436 3.5 40.6684 3.5 38.8549V23.1221C3.5 21.3086 4.9623 19.8334 6.76 19.8334Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.ac48badc6ee645c0729b7ec282cb489d.svg";
export { ForwardRef as ReactComponent };